export default __webpack_public_path__ + "static/turf-e3b4afc317fc53270a5f88048f5f0392.png";